module.exports = __webpack_public_path__ + "static/media/filename (2).5fb8d054.png";